import { SimpleChanges } from '@angular/core';

export const hasInputChanged = (changes: SimpleChanges, valueName: string) => {
  const inputChanges = changes[valueName];

  return inputChanges && inputChanges.currentValue !== inputChanges.previousValue;
};
